import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";

const OrganizationsService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Organizations/List%20Organizations
  getAll: async function (filters) {
    try {
      const path = "/api/v1/organizations/";
      return await RequestService.get(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Organizations/Retrieve%20Organization
  get: async function (organizationId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default OrganizationsService;
